module.exports = __webpack_public_path__ + "5912679922e2c7bb8c45a488ca997cae.png";